export default __webpack_public_path__ + "static/media/io_remove_request.0f8bb7b1.png";